import { Slide as MuiSlide, SlideProps as MuiSlideProps } from '@mui/material'
import styled from 'styled-components'

export type SlidePropsType = MuiSlideProps

const Slide = styled(MuiSlide)<SlidePropsType>``

export default Slide
